module.exports = __webpack_public_path__ + "static/img/img_bg.f3f697e.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img_bg.png
// module id = PNMk
// module chunks = 1